var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchNormal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66671 15.0007C3.90004 15.0007 0.833374 11.934 0.833374 8.16732C0.833374 4.40065 3.90004 1.33398 7.66671 1.33398C11.4334 1.33398 14.5 4.40065 14.5 8.16732C14.5 11.934 11.4334 15.0007 7.66671 15.0007ZM7.66671 2.33398C4.44671 2.33398 1.83337 4.95398 1.83337 8.16732C1.83337 11.3807 4.44671 14.0007 7.66671 14.0007C10.8867 14.0007 13.5 11.3807 13.5 8.16732C13.5 4.95398 10.8867 2.33398 7.66671 2.33398Z",
    fill: "#001F4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 15.6676C14.54 15.6676 14.4133 15.6209 14.3133 15.5209L12.98 14.1876C12.7866 13.9943 12.7866 13.6743 12.98 13.4809C13.1733 13.2876 13.4933 13.2876 13.6866 13.4809L15.02 14.8143C15.2133 15.0076 15.2133 15.3276 15.02 15.5209C14.92 15.6209 14.7933 15.6676 14.6666 15.6676Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchNormal);
export default __webpack_public_path__ + "static/media/search-normal.ea9d2e0c764210fe1b98474e6ee37e52.svg";
export { ForwardRef as ReactComponent };